export default __webpack_public_path__ + "static/media/abstract06.723e7258.webp";